import React from 'react';
import PropTypes from 'prop-types';
import { paymentImageList } from './paymentImageList';

export const PaymentImage = ({ card, width, height }) => {
    const validPayment = paymentImageList.find(obj => obj.type === card);

    return validPayment && (
        <img
            width={width}
            height={height}
            src={validPayment.url}
            alt={validPayment.alt}
        />
    );
};

PaymentImage.defaultProps = {
    width: "27px",
    height: "27px",
};

PaymentImage.propTypes = {
    card: PropTypes.string.isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
};
